export const goToLogin = () => {
    window.location.href = '/login';
};
